import React, {
	FunctionComponent,
	ReactElement,
	useEffect,
	useRef,
	useState,
} from "react";

import { useOutsideClickEvent } from "./hooks";

interface IProps {
	shownComponent: ReactElement;
	editComponent: ReactElement;
	onStartedEditing?: () => void;
	onFinishedEditing: () => void;
	isEditing?: boolean;
}

export const Editable: FunctionComponent<IProps> = props => {
	const [editable, setEditable] = useState(false);

	const wrapperRef = useRef(null);

	const outSideClickCallback = () => {
		setEditable(false);
		props.onFinishedEditing();
	};

	useEffect(() => {
		if (props.isEditing) {
			setEditable(true);
		} else {
			setEditable(false);
		}
	}, [props.isEditing]);

	useOutsideClickEvent(wrapperRef, outSideClickCallback);

	if (editable) {
		return <div ref={wrapperRef}>{props.editComponent}</div>;
	} else {
		return (
			<div
				style={{ display: "inline-block" }}
				onClick={() => {
					setEditable(true);
					if (props.onStartedEditing) {
						props.onStartedEditing();
					}
				}}
			>
				{props.shownComponent}
			</div>
		);
	}
};
